import { Dropdown } from 'antd'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import React from 'react'

import {
  ActionMenu,
  ItemText,
  SmallButtons,
} from 'components/ActionStyles/ActionStyles'
import ResumeDownload from 'components/ResumeDownload'
import { EmptyAnchor } from '../../../../../../../../../../components/UIComponents/CommonStyledDiv'

const StudentDetailsAction = ({ singleStudentData, roleId  }) => {
  const menu = (
    <ActionMenu
      width={'165px'}
      items={[
        {
          key: 'resume',
          label: (
            <ResumeDownload
              triggerButton={<ItemText>Download Resume</ItemText>}
              studentDetails={singleStudentData}
              roleId={roleId}
            />
          ),
        },
      ]}
    />
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <EmptyAnchor onClick={e => e.preventDefault()}>
        <SmallButtons
          width={'40px'}
          height={'38px'}
          icon={<VerticalThreeDots />}
        />
      </EmptyAnchor>
    </Dropdown>
  )
}

export default StudentDetailsAction
